const COUNT_QUANTITY_CHANGES  = '[Search Hotel Form] Quantity changes';
const COUNT_ROOMS_CHANGES     = '[Quantity] Number of rooms changes';
const TOGGLE_SHOW_MAP         = '[Address] Show and hide map';
const TOGGLE_SHOW_DISPATCHING = '[Quantity] Show and hide repartition';

export const All = {
    COUNT_QUANTITY_CHANGES,
    COUNT_ROOMS_CHANGES,
    TOGGLE_SHOW_MAP,
    TOGGLE_SHOW_DISPATCHING
};
